import { Phone, Mail, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import logo from '@/assets/logo.png';

function InstagramIcon({ className }: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
    </svg>
  );
}

function FacebookIcon({ className }: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
    </svg>
  );
}

export function Footer() {
  return (
    <footer className="bg-foreground text-primary-foreground py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <img src={logo} alt="Barbor Meals" className="h-12 w-auto mb-4 invert" />
            <p className="text-primary-foreground/70 leading-relaxed">
              אנחנו מכינים מנות בריאות וטעימות עבור אנשים שמחפשים לשמור על אורח חיים בריא מבלי להתפשר על הטעם.
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-3 mt-4">
              <a
                href="https://www.instagram.com/barbormeals"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 transition-colors"
                aria-label="Instagram"
              >
                <InstagramIcon className="h-5 w-5" />
              </a>
              <a
                href="https://www.facebook.com/barbormeals"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 transition-colors"
                aria-label="Facebook"
              >
                <FacebookIcon className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">צרו קשר</h3>
            <div className="space-y-3">
              <a
                href="tel:+972546862515"
                className="flex items-center gap-3 text-primary-foreground/70 hover:text-primary-foreground transition-colors"
              >
                <Phone className="h-5 w-5" />
                054-686-2515
              </a>
              <a
                href="mailto:info@barbormeals.com"
                className="flex items-center gap-3 text-primary-foreground/70 hover:text-primary-foreground transition-colors"
              >
                <Mail className="h-5 w-5" />
                info@barbormeals.com
              </a>
              <div className="flex items-center gap-3 text-primary-foreground/70">
                <MapPin className="h-5 w-5" />
                נצרת רח 9010
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">קישורים</h3>
            <div className="space-y-2">
              <Link to="/meals" className="block text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                התפריט שלנו
              </Link>
              <Link to="/cart" className="block text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                סל קניות
              </Link>
              <Link to="/terms" className="block text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                תקנון האתר
              </Link>
              <Link to="/privacy" className="block text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                מדיניות פרטיות
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 mt-10 pt-6 text-center text-primary-foreground/50">
          <p className="mb-4">© 2026 Barbor Meals. כל הזכויות שמורות.</p>
          <div className="flex justify-center gap-2 sm:gap-4 flex-wrap">
            <Link to="/shipping" className="hover:text-primary-foreground transition-colors underline py-2 px-2 min-h-[44px] flex items-center text-sm sm:text-base">
              מדיניות משלוחים
            </Link>
            <Link to="/returns" className="hover:text-primary-foreground transition-colors underline py-2 px-2 min-h-[44px] flex items-center text-sm sm:text-base">
              מדיניות החזרות
            </Link>
            <Link to="/accessibility" className="hover:text-primary-foreground transition-colors underline py-2 px-2 min-h-[44px] flex items-center text-sm sm:text-base">
              הצהרת נגישות
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
